const STATUS = {
    CONFIRM_SIGNATURE:'CONFIRM_SIGNATURE',
    CONFIRM_SIGNATURE_SIGN_ALL: 'CONFIRM_SIGNATURE_SIGN_ALL',
    DEFAULT: 'DEFAULT'
}

export default STATUS;
